var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{ref:"overviewmapPanel",staticClass:"pa-1",attrs:{"width":_vm.width,"height":_vm.height,"elevation":"8"}})
}
var staticRenderFns = []

export { render, staticRenderFns }